import { SelectListComponent } from './../../shared/component/list-filter/select.list.component';
import { DatePipe } from '@angular/common';
import { DashboardService } from './../../dashboard/dashboard.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { SharedService } from '../../shared/shared.service';
import { UserService } from '../user/user.service';


declare var $: any;

@Component({
    selector: 'app-agent-report',
    templateUrl: './agent-report.component.html',
    styleUrls: ['./agent-report.component.scss']
})

export class AgentReportComponent implements OnInit {

    public filter: FormGroup;
    public flag_toShow: boolean = false;
    public show_variable_1: any;
    public date_init: any = '';
    public date_end: any = '';
    public agent_selected: any = '';
    public group_by: any = '';
    public nivel_servicio: any = 0;
    public color = "";
    public text_class = "";

    public modal_title: string;
    public modal_body: string;
    public agents: any;
    public new_data: any;
    public new_data_2: any = [];
    public new_data_3: any = [];
    public dataExcel: any = [];
    public dataExcel_3: any = [];
    public select_list: string[] = [
        "DIA",
        "SEMANA",
        "MES"
    ];
    public select_from_list: string = "DIA";

    // Nuevo Desarrollo
    public dropdownList = [];
    public selectedItems = [];
    public dropdownSettings: IDropdownSettings = {};
    public flagToDisplay = true;
    public newArray: any = [];
    public banderaRepor: any;

    constructor(
        private fb: FormBuilder,
        private _dashboardService: DashboardService,
        private spinner: NgxSpinnerService,
        private datePipe: DatePipe,
        private sharedService: SharedService,
        private userService: UserService
    ) {
        this.filter = this.fb.group({
            date_start_report: ['', Validators.required],
            date_end_report: ['', Validators.required],
            group_by: ['DIA'],
            nivel_servicio: 20,
            agent: ['', Validators.required],
        });
    }

    ngOnInit() {
        let cookie = {
            auth_token: this.sharedService.getCookie("auth_token"),
        };

        this.userService.getAllAgentsInReport(cookie).subscribe(res => {
            this.dropdownList = res.data;
            this.flagToDisplay = false;
        }, error => {
            console.log('Ups, Hubo un error: ', error);
        });
        this.dropdownSettings = {
            singleSelection: false,
            idField: 'id',
            textField: 'fullname',
            selectAllText: 'Seleccionar Todos',
            unSelectAllText: 'Remover Todos',
            itemsShowLimit: 5,
            allowSearchFilter: true
        };
    }
    onItemSelect(item: any) {
        console.log(item);
    }
    onSelectAll(items: any) {
        console.log(items);
    }
    /*
    onFilter(){
      this.spinner.show();
    }*/

    onFilter() {
        this.agent_selected = [];
        this.newArray = [];
        this.agent_selected = this.filter.value.agent;
        this.date_init = this.filter.value.date_start_report;
        this.date_end = this.filter.value.date_end_report;
        this.group_by = this.filter.value.group_by;
        this.nivel_servicio = this.filter.value.nivel_servicio;

        this.agent_selected.map(item => {
            this.newArray.push(
                item.id
            );
        });
        let data_to_backend = {
            rango_inicio: this.date_init,
            rango_fin: this.date_end,
            group_by: this.group_by,
            nivel_servicio: this.nivel_servicio,
            agents: this.newArray
        };
        let actual_day = new Date();
        actual_day.setDate(actual_day.getDate()+60);
        
        let maxRango = this.datePipe.transform(actual_day, "yyyy-MM-dd");
        console.log('max',maxRango);
        console.log('end',this.date_end);

        if (this.date_init > this.date_end || this.date_end > maxRango) {
            this.modal_title = 'Advertencia';
            this.modal_body = 'Rango de Fechas Inválido',
                $('#controlRoom').modal('toggle', { backdrop: false });
            $('#controlRoom').appendTo("body");
        } else {
            this.spinner.show();
            this._dashboardService.getReportForAgents(data_to_backend).subscribe(data => {

                this.new_data_2 = [];
                this.new_data_3 = [];
                this.dataExcel = [];
                this.dataExcel_3 = [];

                for (let i in data.data) {
                    let temp = [];

                    temp['intervalo'] = data.data[i].intervalo;
                    temp['total_chats'] = data.data[i].total_chats;
                    temp['answered_chats'] = data.data[i].answered_chats;
                    temp['agentes_conectados'] = data.data[i].agentes_conectados;
                    temp['nivel_servicio'] = (data.data[i].nivel_servicio).toFixed(2) + "%";
                    temp['nivel_atencion'] = (data.data[i].nivel_atencion).toFixed(2) + "%";

                    if (data.data[i].nivel_servicio <= 35) {
                        temp['color'] = "#f95555";
                        this.text_class = "text-white";
                    } else if ((data.data[i].nivel_servicio > 35) && (data.data[i].nivel_servicio <= 80)) {
                        temp['color'] = "#f38b56";
                        this.text_class = "text-white";
                    } else {
                        temp['color'] = "#75e44e";
                        this.text_class = "text-white";
                    }

                    if (data.data[i].nivel_atencion <= 35) {
                        temp['color_atencion'] = "#f95555";
                        this.text_class = "text-white";
                    } else if ((data.data[i].nivel_atencion > 35) && (data.data[i].nivel_atencion <= 80)) {
                        temp['color_atencion'] = "#f38b56";
                        this.text_class = "text-white";
                    } else {
                        temp['color_atencion'] = "#75e44e";
                        this.text_class = "text-white";
                    }

                    if (data.data[i].TMA) {
                        // Acá calculo las horas minutos y segundos de Tiempo total promedio de activos.
                        let h_tiempoTotal = Math.floor(data.data[i].TMA / 3600);         // Horas
                        let m_tiempoTotal = Math.floor((data.data[i].TMA % 3600) / 60);  // Minutos
                        let s_tiempoTotal = Math.floor((data.data[i].TMA % 3600) % 60);  // Segundos

                        temp['TMA_horas_activo'] = h_tiempoTotal > 0 ? (h_tiempoTotal > 9 ? h_tiempoTotal + ":" : "0" + h_tiempoTotal + ":") : "00:";
                        temp['TMA_minutos_activo'] = m_tiempoTotal > 0 ? (m_tiempoTotal > 9 ? m_tiempoTotal + ":" : "0" + m_tiempoTotal + ":") : "00:";
                        temp['TMA_segundos_activo'] = s_tiempoTotal > 0 ? (s_tiempoTotal > 9 ? s_tiempoTotal + "" : "0" + s_tiempoTotal + "") : "00";

                    } else {
                        temp['TMA_horas_activo'] = "00:";
                        temp['TMA_minutos_activo'] = "00:";
                        temp['TMA_segundos_activo'] = "00";
                    }

                    if (data.data[i].TME) {
                        // Cálculo de las horas minutos y segundos del tiempo promedio. Por Agente.
                        let h_tiempoTotalEspera = Math.floor(data.data[i].TME / 3600);
                        let m_tiempoTotalEspera = Math.floor(data.data[i].TME % 3600 / 60);
                        let s_tiempoTotalEspera = Math.floor((data.data[i].TME % 3600) % 60);

                        temp['TME_horas_espera'] = h_tiempoTotalEspera > 0 ? (h_tiempoTotalEspera > 9 ? h_tiempoTotalEspera + ":" : "0" + h_tiempoTotalEspera + ":") : "00:";
                        temp['TME_minutos_espera'] = m_tiempoTotalEspera > 0 ? (m_tiempoTotalEspera > 9 ? m_tiempoTotalEspera + ":" : "0" + m_tiempoTotalEspera + ":") : "00:";
                        temp['TME_segundos_espera'] = s_tiempoTotalEspera > 0 ? (s_tiempoTotalEspera > 9 ? s_tiempoTotalEspera + "" : "0" + s_tiempoTotalEspera + "") : "00";

                    } else {
                        temp['TME_horas_espera'] = "00:";
                        temp['TME_minutos_espera'] = "00:";
                        temp['TME_segundos_espera'] = "00";
                    }

                    if (data.data[i].TMO) {
                        // Acá calculo las horas minutos y segundos de Tiempo total promedio de activos.
                        let h_tiempoTotal_tmo = Math.floor(data.data[i].TMO / 3600);         // Horas
                        let m_tiempoTotal_tmo = Math.floor((data.data[i].TMO % 3600) / 60);  // Minutos
                        let s_tiempoTotal_tmo = Math.floor((data.data[i].TMO % 3600) % 60);  // Segundos

                        temp['TMO_horas_activo'] = h_tiempoTotal_tmo > 0 ? (h_tiempoTotal_tmo > 9 ? h_tiempoTotal_tmo + ":" : "0" + h_tiempoTotal_tmo + ":") : "00:";
                        temp['TMO_minutos_activo'] = m_tiempoTotal_tmo > 0 ? (m_tiempoTotal_tmo > 9 ? m_tiempoTotal_tmo + ":" : "0" + m_tiempoTotal_tmo + ":") : "00:";
                        temp['TMO_segundos_activo'] = s_tiempoTotal_tmo > 0 ? (s_tiempoTotal_tmo > 9 ? s_tiempoTotal_tmo + "" : "0" + s_tiempoTotal_tmo + "") : "00";
                    } else {
                        temp['TMO_horas_activo'] = "00:";
                        temp['TMO_minutos_activo'] = "00:";
                        temp['TMO_segundos_activo'] = "00";
                    }
                    this.new_data_2.push(temp);
                }

                this._dashboardService.getReportForAgentsExcel(data_to_backend).subscribe(data => {
                    console.log('Data recibida', data.data);
                    for (let i in data.data) {
                        let temporal = [];
                        let tempExcel = [];
                        tempExcel['dia'] = data.data[i].dia;
                        tempExcel['intervalo'] = data.data[i].intervalo;
                        tempExcel['total_chats'] = data.data[i].total_chats;
                        tempExcel['answered_chats'] = data.data[i].answered_chats;
                        tempExcel['agentes_conectados'] = data.data[i].agentes_conectados;
                        tempExcel['nivel_servicio'] = (data.data[i].nivel_servicio).toFixed(2) + "%";
                        tempExcel['nivel_atencion'] = (data.data[i].nivel_atencion).toFixed(2) + "%";

                        if (data.data[i].TMA) {
                            // Acá calculo las horas minutos y segundos de Tiempo total promedio de activos.
                            let h_tiempoTotal = Math.floor(data.data[i].TMA / 3600);         // Horas
                            let m_tiempoTotal = Math.floor((data.data[i].TMA % 3600) / 60);  // Minutos
                            let s_tiempoTotal = Math.floor((data.data[i].TMA % 3600) % 60);  // Segundos

                            temporal['TMA_horas_activo'] = h_tiempoTotal > 0 ? (h_tiempoTotal > 9 ? h_tiempoTotal + ":" : "0" + h_tiempoTotal + ":") : "00:";
                            temporal['TMA_minutos_activo'] = m_tiempoTotal > 0 ? (m_tiempoTotal > 9 ? m_tiempoTotal + ":" : "0" + m_tiempoTotal + ":") : "00:";
                            temporal['TMA_segundos_activo'] = s_tiempoTotal > 0 ? (s_tiempoTotal > 9 ? s_tiempoTotal + "" : "0" + s_tiempoTotal + "") : "00";
                            tempExcel['TMA'] = temporal['TMA_horas_activo'] + temporal['TMA_minutos_activo'] + temporal['TMA_segundos_activo'];

                        } else {
                            temporal['TMA_horas_activo'] = "00:";
                            temporal['TMA_minutos_activo'] = "00:";
                            temporal['TMA_segundos_activo'] = "00";
                            tempExcel['TMA'] = temporal['TMA_horas_activo'] + temporal['TMA_minutos_activo'] + temporal['TMA_segundos_activo'];
                        }

                        if (data.data[i].TME) {
                            // Cálculo de las horas minutos y segundos del tiempo promedio. Por Agente.
                            let h_tiempoTotalEspera = Math.floor(data.data[i].TME / 3600);
                            let m_tiempoTotalEspera = Math.floor(data.data[i].TME % 3600 / 60);
                            let s_tiempoTotalEspera = Math.floor((data.data[i].TME % 3600) % 60);

                            temporal['TME_horas_espera'] = h_tiempoTotalEspera > 0 ? (h_tiempoTotalEspera > 9 ? h_tiempoTotalEspera + ":" : "0" + h_tiempoTotalEspera + ":") : "00:";
                            temporal['TME_minutos_espera'] = m_tiempoTotalEspera > 0 ? (m_tiempoTotalEspera > 9 ? m_tiempoTotalEspera + ":" : "0" + m_tiempoTotalEspera + ":") : "00:";
                            temporal['TME_segundos_espera'] = s_tiempoTotalEspera > 0 ? (s_tiempoTotalEspera > 9 ? s_tiempoTotalEspera + "" : "0" + s_tiempoTotalEspera + "") : "00";

                            tempExcel['TME'] = temporal['TME_horas_espera'] + temporal['TME_minutos_espera'] + temporal['TME_segundos_espera'];
                        } else {
                            temporal['TME_horas_espera'] = "00:";
                            temporal['TME_minutos_espera'] = "00:";
                            temporal['TME_segundos_espera'] = "00";
                            tempExcel['TME'] = temporal['TME_horas_espera'] + temporal['TME_minutos_espera'] + temporal['TME_segundos_espera'];
                        }

                        if (data.data[i].TMO) {
                            // Acá calculo las horas minutos y segundos de Tiempo total promedio de activos.
                            let h_tiempoTotal_tmo = Math.floor(data.data[i].TMO / 3600);         // Horas
                            let m_tiempoTotal_tmo = Math.floor((data.data[i].TMO % 3600) / 60);  // Minutos
                            let s_tiempoTotal_tmo = Math.floor((data.data[i].TMO % 3600) % 60);  // Segundos

                            temporal['TMO_horas_activo'] = h_tiempoTotal_tmo > 0 ? (h_tiempoTotal_tmo > 9 ? h_tiempoTotal_tmo + ":" : "0" + h_tiempoTotal_tmo + ":") : "00:";
                            temporal['TMO_minutos_activo'] = m_tiempoTotal_tmo > 0 ? (m_tiempoTotal_tmo > 9 ? m_tiempoTotal_tmo + ":" : "0" + m_tiempoTotal_tmo + ":") : "00:";
                            temporal['TMO_segundos_activo'] = s_tiempoTotal_tmo > 0 ? (s_tiempoTotal_tmo > 9 ? s_tiempoTotal_tmo + "" : "0" + s_tiempoTotal_tmo + "") : "00";
                            tempExcel['TMO'] = temporal['TMO_horas_activo'] + temporal['TMO_minutos_activo'] + temporal['TMO_segundos_activo'];
                        } else {
                            temporal['TMO_horas_activo'] = "00:";
                            temporal['TMO_minutos_activo'] = "00:";
                            temporal['TMO_segundos_activo'] = "00";
                            tempExcel['TMO'] = temporal['TMO_horas_activo'] + temporal['TMO_minutos_activo'] + temporal['TMO_segundos_activo'];
                        }
                        this.dataExcel.push(tempExcel);
                    }
                    this.spinner.hide();

                }, error => {
                    //console.log(error);
                    this.spinner.hide();
                })

                this.flag_toShow = true;

                //console.log(this.new_data_2);
                //console.log(this.new_data);
            }, error => {
                //console.log(error);
                this.spinner.hide();
            })
            
        }
    }
    exportAsXLSX(): void {
        if ('chats' == this.banderaRepor) {
            this.userService.exportAsExcelFile(this.dataExcel, 'reporte');
        } else {
            this.userService.exportAsExcelFile(this.dataExcel_3, 'reporte');
        }
    }
}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/agent-report/agent-report.component.ts